<script setup lang="ts">
import { computed } from "vue";
import { moneyUsdExtendFormat } from "~/utils/formatters/money.formatter";

const props = defineProps({
    price: Number,
    currencyClass: String,
    pricePart1Class: String,
    pricePart2Class: String,
});

const priceParse = computed(() => moneyUsdExtendFormat(Number(props.price)))
</script>

<template>
    <span :class="currencyClass">{{ priceParse.currency }}</span>
    <span :class="pricePart1Class">{{ priceParse.parts[0] }}</span>
    <span :class="pricePart2Class">.{{ priceParse.parts[1] ? priceParse.parts[1] : '00' }}</span>
</template>